(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ym-shipping-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ym-shipping-choice')) {
    customElements.define('ym-shipping-choice', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.onChoiceChange = (event) => {
          if (event.target.matches('[data-backorder-ack]')) {
            this.querySelector('[data-backorder-ack-value]').value = event.target.checked ? 'confirmed' : '';
            this.querySelector('[data-ack-error]').hidden = true;
            this.updateEligibility();
            return;
          }
          if (!event.target.matches('input[type="radio"]')) return;
          const mode = event.target.value;
          this.dataset.mode = mode;
          const preferenceInput = this.querySelector('[data-reset-preference]');
          if (preferenceInput) preferenceInput.value = mode;
          this.querySelectorAll('[data-plan]').forEach((panel) => { panel.hidden = panel.dataset.plan !== mode; });
        };
        this.addEventListener('change', this.onChoiceChange);
        if (this.hasAttribute('data-demo')) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.quantityInputs = Array.from(this.form.querySelectorAll('[data-ym-line-key]'));
        this.originalQuantities = this.quantityInputs.map((input) => input.value);
        this.checkout = this.form.querySelector('[data-ym-checkout]');
        this.status = this.querySelector('[data-launch-status]');
        this.reload = this.querySelector('[data-launch-reload]');
        this.busy = false;
        try { this.reviewed = JSON.parse(this.querySelector('[data-ym-stock-state]').textContent); }
        catch (_) { this.showStatus(this.dataset.error, true); return; }
        this.checkQuantities = () => {
          if (this.quantityInputs.some((input, index) => input.value !== this.originalQuantities[index])) this.invalidateChoice();
        };
        this.onCartClick = (event) => {
          if (event.target.closest('.qtyBtn')) requestAnimationFrame(this.checkQuantities);
          if (event.target.closest('.cart__remove')) this.invalidateChoice();
        };
        this.onSubmit = (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.saveChanges();
        };
        this.onCheckout = (event) => {
          if (this.replaying === event.currentTarget) return;
          event.preventDefault(); event.stopImmediatePropagation(); this.beginCheckout(event.currentTarget);
        };
        this.onPageShow = (event) => { if (event.persisted) { this.busy = false; this.invalidateChoice(true, true); } };
        this.onServiceReady = () => this.enableWhenReady();
        this.form.addEventListener('input', this.checkQuantities);
        this.form.addEventListener('change', this.checkQuantities);
        this.form.addEventListener('click', this.onCartClick);
        this.form.addEventListener('submit', this.onSubmit, true);
        this.checkout.addEventListener('click', this.onCheckout);
        window.addEventListener('pageshow', this.onPageShow);
        document.addEventListener('ym:shipping-ready', this.onServiceReady);
        if (window.jQuery) window.jQuery(this.form).on('change.ymShippingChoice', this.checkQuantities);
        if (window.YMShipping) this.enableWhenReady();
      }
      async enableWhenReady() {
        try {
          window.YMShipping.validateState(this.reviewed);
          await window.YMShipping.ready;
          this.ready = true;
          this.updateEligibility();
        } catch (_) { this.showStatus(this.dataset.error, true); }
      }
      updateEligibility() {
        if (!this.checkout) return;
        const ack = this.querySelector('[data-backorder-ack]');
        this.checkout.disabled = this.busy || !this.ready || this.dataset.dirty === 'true' || Boolean(ack && !ack.checked);
        this.checkout.setAttribute('aria-disabled', String(this.checkout.disabled));
        const net = this.form.querySelector('#wh-30-open');
        if (net) net.setAttribute('aria-disabled', String(this.checkout.disabled));
      }
      showStatus(message, failed = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.hidden = false;
        this.reload.hidden = !failed;
        if (failed) this.status.focus();
      }
      lock() {
        this.busy = true;
        this.controls = Array.from(this.form.querySelectorAll('input,button,textarea,select,fieldset')).map((control) => [control, control.disabled]);
        this.controls.forEach(([control]) => { control.disabled = true; });
        this.checkout.setAttribute('aria-disabled', 'true');
        this.showStatus(this.dataset.loading);
      }
      unlock() {
        (this.controls || []).forEach(([control, disabled]) => { control.disabled = disabled; });
        this.busy = false;
        this.updateEligibility();
      }
      getNote() {
        const note = this.form.querySelector('[name="note"]');
        return note ? note.value : undefined;
      }
      async saveChanges() {
        if (this.busy || !window.YMShipping || window.YMShipping.checkoutBusy) return;
        if (this.reloadOnly) { window.location.assign(window.YMShipping.cartUrl); return; }
        const updates = {};
        try {
          this.quantityInputs.forEach((input) => {
            if (!/^\d+$/.test(input.value.trim())) throw new Error('INVALID_QUANTITY');
            updates[input.dataset.ymLineKey] = Number(input.value);
          });
          const note = this.getNote();
          this.lock();
          await window.YMShipping.saveCart(updates, note);
          window.location.assign(window.YMShipping.cartUrl);
        } catch (_) { this.unlock(); this.showStatus(this.dataset.error, true); }
      }
      async beginCheckout(target = this.checkout, submitter) {
        if (this.busy || !window.YMShipping || window.YMShipping.checkoutBusy) return;
        this.checkQuantities();
        if (this.dataset.dirty === 'true') { await this.saveChanges(); return; }
        const ack = this.querySelector('[data-backorder-ack]');
        if (ack && !ack.checked) {
          const error = this.querySelector('[data-ack-error]');
          error.hidden = false;
          error.focus();
          return;
        }
        const selected = this.querySelector('input[type="radio"]:checked');
        const preference = selected ? selected.value : 'together';
        const acknowledged = Boolean(ack && ack.checked);
        const note = this.getNote();
        this.lock();
        window.YMShipping.checkoutBusy = true;
        try {
          await window.YMShipping.ready;
          const fresh = await window.YMShipping.handoff(this.reviewed, preference, acknowledged, note);
          window.YMShipping.canonicalAttributes(this.form, fresh.attributes);
          const isNetForm = target instanceof HTMLFormElement;
          const isNetOpen = target.id === 'wh-30-open';
          if (!isNetForm && !isNetOpen && target === this.checkout) {
            let checkoutForm = document.querySelector('[data-ym-checkout-only]');
            if (!checkoutForm) {
              checkoutForm = document.createElement('form');
              checkoutForm.method = 'post';
              checkoutForm.action = window.YMShipping.cartUrl;
              checkoutForm.id = 'ym-guarded-checkout-form';
              checkoutForm.hidden = true;
              checkoutForm.setAttribute('data-ym-checkout-only', '');
              document.body.appendChild(checkoutForm);
            }
            this.checkout.type = 'submit';
            this.checkout.setAttribute('form', checkoutForm.id);
          }
          this.unlock();
          this.replaying = target;
          window.YMShipping.allowOriginalOnce(target);
          if (isNetForm) target.requestSubmit(submitter || undefined);
          else target.click();
          this.replaying = null;
          window.YMShipping.checkoutBusy = false;
          this.status.hidden = true;
        } catch (error) {
          try { await window.YMShipping.invalidate(); } catch (_) {}
          window.YMShipping.checkoutBusy = false;
          this.unlock();
          this.invalidateChoice(true, true);
          this.showStatus(error.message === 'REVIEW_CHANGED' ? this.dataset.changed : this.dataset.error, true);
        }
      }
      clearAcknowledgement() {
        const ack = this.querySelector('[data-backorder-ack]');
        if (ack) ack.checked = false;
        const value = this.querySelector('[data-backorder-ack-value]');
        if (value) value.value = '';
      }
      invalidateChoice(persist = true, reloadOnly = false) {
        if (this.hasAttribute('data-demo') || !this.form) return;
        this.reloadOnly = this.reloadOnly || reloadOnly;
        this.dataset.dirty = 'true';
        this.dataset.mode = 'together';
        this.clearAcknowledgement();
        const ack = this.querySelector('[data-backorder-ack]');
        if (ack) ack.disabled = true;
        const fieldset = this.querySelector('fieldset');
        if (fieldset) fieldset.disabled = true;
        this.querySelectorAll('[data-plan]').forEach((panel) => { panel.hidden = true; });
        this.querySelector('[data-cart-changed]').hidden = false;
        const fallback = this.querySelector('[data-reset-preference]');
        fallback.name = 'attributes[ym_shipping_preference]';
        fallback.value = 'together';
        fallback.disabled = false;
        if (window.YMShipping) window.YMShipping.resetLocalAttributes(this.form);
        this.form.querySelectorAll('[data-cart-stock-warning]').forEach((warning) => { warning.hidden = true; });
        this.updateEligibility();
        if (persist && window.YMShipping && !window.YMShipping.checkoutBusy) window.YMShipping.invalidate().catch(() => this.showStatus(this.dataset.error, true));
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChoiceChange);
        if (this.form) {
          this.form.removeEventListener('input', this.checkQuantities);
          this.form.removeEventListener('change', this.checkQuantities);
          this.form.removeEventListener('click', this.onCartClick);
          this.form.removeEventListener('submit', this.onSubmit, true);
          if (this.checkout) this.checkout.removeEventListener('click', this.onCheckout);
          if (window.jQuery) window.jQuery(this.form).off('change.ymShippingChoice', this.checkQuantities);
        }
        window.removeEventListener('pageshow', this.onPageShow);
        document.removeEventListener('ym:shipping-ready', this.onServiceReady);
        this.initialized = false;
        this.form = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-shipping-launch-runtime"] && !Shopify.designMode) return;
  try {
    if (!window.YMShipping) {
    const config = document.querySelector('[data-ym-shipping-config]');
    if (config) {
      const cartUrl = new URL(config.dataset.cartUrl, window.location.origin);
      const modeKey = 'ym_shipping_mode';
      const resetAttributes = { ym_shipping_mode: 'together', ym_shipping_preference: 'together', ym_backorder_acknowledged: '', ym_shipping_stock_state: '', ym_has_backorder: 'yes', ym_cod_eligibility_v1: 'blocked' };
      let queue = Promise.resolve();
      let invalidation = null;
      let sequence = 0;
      const replay = new WeakSet();
      function fingerprint(cart) {
        if (!cart || !Array.isArray(cart.items) || typeof cart.currency !== 'string') throw new Error('INVALID_CART');
        const items = cart.items.map((item) => {
          const variant = String(item.variant_id || item.id);
          const plan = String(item.selling_plan_id || (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || 0);
          if (typeof item.key !== 'string' || !/^\d+$/.test(variant) || !/^\d+$/.test(plan) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0 || typeof item.requires_shipping !== 'boolean') throw new Error('INVALID_LINE');
          return [item.key, variant, item.quantity, item.final_line_price, plan, item.requires_shipping];
        }).sort((a, b) => a[0].localeCompare(b[0]));
        const subtotal = items.reduce((sum, item) => sum + item[3], 0);
        if (!Number.isSafeInteger(subtotal)) throw new Error('INVALID_SUBTOTAL');
        return JSON.stringify([cart.currency, subtotal, items]);
      }
      function validateState(state) {
        if (!state || state.version !== 1) throw new Error('INVALID_STATE');
        fingerprint(state);
        for (const key of ['ready', 'waiting', 'unknown', 'item_count']) if (!Number.isSafeInteger(state[key]) || state[key] < 0) throw new Error('INVALID_COUNTS');
        if (state.items.reduce((sum, item) => sum + item.quantity, 0) !== state.item_count) throw new Error('INCOMPLETE_CART');
        if (state.items.reduce((sum, item) => sum + (item.requires_shipping ? item.quantity : 0), 0) !== state.ready + state.waiting + state.unknown) throw new Error('INVALID_CLASSIFICATION');
        const expected = state.ready > 0 && state.waiting > 0 && state.unknown === 0 ? 'mixed' : 'single';
        if (state.gate !== expected) throw new Error('INVALID_GATE');
        return state;
      }
      function sameReview(left, right) {
        return fingerprint(left) === fingerprint(right) && ['gate', 'ready', 'waiting', 'unknown'].every((key) => left[key] === right[key]);
      }
      function run(task) {
        const next = queue.then(task, task);
        queue = next.catch(() => {});
        return next;
      }
      async function request(url, options = {}) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
          if (!response.ok) throw new Error('HTTP_' + response.status);
          return options.html ? response.text() : response.json();
        } finally { clearTimeout(timeout); }
      }
      function update(payload) {
        return request(cartUrl.pathname + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      }
      async function reset() {
        const cart = await update({ attributes: resetAttributes });
        if (!cart.attributes || cart.attributes[modeKey] !== 'together' || cart.attributes.ym_has_backorder !== 'yes' || cart.attributes.ym_cod_eligibility_v1 !== 'blocked') throw new Error('RESET_NOT_SAVED');
        return cart;
      }
      function invalidate() {
        if (!invalidation) invalidation = run(reset).finally(() => { invalidation = null; });
        return invalidation;
      }
      async function freshState() {
        const url = new URL(cartUrl);
        url.searchParams.set('view', 'ym-shipping-state');
        url.searchParams.set('_ym', Date.now() + '-' + (++sequence));
        const html = await request(url.href, { html: true });
        const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ym-stock-state]');
        if (!node) throw new Error('STATE_NOT_RENDERED');
        return validateState(JSON.parse(node.textContent));
      }
      async function handoff(reviewed, preference, acknowledged, note) {
        return run(async () => {
          try {
          await reset();
          const fresh = await freshState();
          if (!sameReview(reviewed, fresh)) throw new Error('REVIEW_CHANGED');
          if (!fresh.items.length) throw new Error('EMPTY_CART');
          if (fresh.waiting > 0 && !acknowledged) throw new Error('ACK_REQUIRED');
          if (!['together', 'separate'].includes(preference)) throw new Error('INVALID_MODE');
          if (preference === 'separate' && (fresh.gate !== 'mixed' || !acknowledged)) throw new Error('SEPARATE_NOT_ALLOWED');
          const attributes = { ym_shipping_mode: preference, ym_shipping_preference: preference, ym_backorder_acknowledged: fresh.waiting > 0 && acknowledged ? 'confirmed' : '', ym_shipping_stock_state: fresh.gate, ym_has_backorder: fresh.waiting > 0 || fresh.unknown > 0 ? 'yes' : 'no', ym_cod_eligibility_v1: fresh.ready > 0 && fresh.waiting === 0 && fresh.unknown === 0 ? 'verified_in_stock' : 'blocked' };
          const payload = { attributes };
          if (typeof note === 'string') payload.note = note;
          const saved = await update(payload);
          if (fingerprint(saved) !== fingerprint(fresh)) throw new Error('CART_CHANGED_DURING_SAVE');
          if (!saved.attributes || Object.entries(attributes).some(([key, value]) => (saved.attributes[key] || '') !== value)) throw new Error('ATTRIBUTES_NOT_SAVED');
          return { ...fresh, attributes };
          } catch (error) {
            try { await reset(); } catch (_) {}
            throw error;
          }
        });
      }
      async function saveCart(updates, note) {
        return run(async () => {
          for (const quantity of Object.values(updates)) if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error('INVALID_QUANTITY');
          const payload = { updates, attributes: resetAttributes };
          if (typeof note === 'string') payload.note = note;
          const saved = await update(payload);
          if (!saved.attributes || saved.attributes[modeKey] !== 'together' || saved.attributes.ym_has_backorder !== 'yes' || saved.attributes.ym_cod_eligibility_v1 !== 'blocked') throw new Error('RESET_NOT_SAVED');
          return saved;
        });
      }
      function canonicalAttributes(form, attributes) {
        for (const [key, value] of Object.entries(attributes)) {
          const inputs = Array.from(document.querySelectorAll('[name="attributes[' + key + ']"]'));
          let input = inputs.shift();
          inputs.forEach((extra) => extra.removeAttribute('name'));
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'attributes[' + key + ']'; form.appendChild(input); }
          input.value = value;
        }
        for (const appCart of [window.wh_data && window.wh_data.wh_cart, window.wcp_data && window.wcp_data.wcp_cart]) {
          if (!appCart) continue;
          appCart.attributes = { ...(appCart.attributes || {}), ...attributes };
          const previous = Array.isArray(appCart.note_attributes) ? appCart.note_attributes.filter((attribute) => !Object.hasOwn(attributes, attribute.name)) : [];
          appCart.note_attributes = previous.concat(Object.entries(attributes).map(([name, value]) => ({ name, value })));
        }
      }
      const service = { cartUrl: cartUrl.href, fingerprint, validateState, sameReview, invalidate, handoff, saveCart, canonicalAttributes, resetLocalAttributes: form => canonicalAttributes(form, resetAttributes), allowOriginalOnce: target => replay.add(target), checkoutBusy: false };
      window.YMShipping = service;
      function showError(target) {
        const scope = target.closest('form') || target.parentElement || document.body;
        let error = scope.querySelector('[data-ym-request-error]');
        if (!error) { error = document.createElement('p'); error.setAttribute('data-ym-request-error', ''); error.setAttribute('role', 'alert'); scope.appendChild(error); }
        error.textContent = config.dataset.error;
      }
      function changed() {
        document.querySelectorAll('ym-shipping-choice:not([data-demo])').forEach((choice) => choice.invalidateChoice && choice.invalidateChoice(false, true));
      }
      function pathOf(value) {
        try { return new URL(value, window.location.origin).pathname; } catch (_) { return ''; }
      }
      document.addEventListener('click', async (event) => {
        const target = event.target.closest('button,input,a');
        if (!target) return;
        if (replay.has(target)) { replay.delete(target); return; }
        const href = target.getAttribute('href');
        const path = href ? pathOf(href) : '';
        const isDirectCheckout = /\/(checkout|checkouts)(\/|$)/.test(path) || ['checkout', 'goto_pp', 'goto_gc'].includes(target.name);
        const guardedChoice = document.querySelector('ym-shipping-choice:not([data-demo])');
        if (guardedChoice && (isDirectCheckout || target.matches('#wh-30-open,.wcp_checkout_btn,.wds_checkout_btn'))) {
          event.preventDefault(); event.stopImmediatePropagation();
          if (!service.checkoutBusy && guardedChoice.beginCheckout) guardedChoice.beginCheckout(target);
          return;
        }
        if (isDirectCheckout && !target.hasAttribute('data-ym-checkout')) {
          event.preventDefault(); event.stopImmediatePropagation();
          if (service.checkoutBusy) return;
          try { await invalidate(); window.location.assign(cartUrl.href); } catch (_) { showError(target); }
          return;
        }
        const productAdd = target.matches('.product-form__cart-submit') && target.closest('form');
        const cartMutation = target.matches('[data-cart-remove],[data-cart-update],[rv-data-cart-remove],[rv-data-cart-update]') || /\/cart\/(change|clear)$/.test(path);
        if (!productAdd && !cartMutation) return;
        if (target.disabled) return;
        event.preventDefault(); event.stopImmediatePropagation();
        if (service.checkoutBusy || target.dataset.ymPending === 'true') return;
        target.dataset.ymPending = 'true';
        try {
          await invalidate();
          changed();
          if (/\/cart\/(change|clear)$/.test(path)) window.location.assign(new URL(href, window.location.origin).href);
          else { replay.add(target); target.click(); }
        } catch (_) { showError(target); }
        finally { delete target.dataset.ymPending; }
      }, true);
      document.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-ym-cart-form') || form.hasAttribute('data-ym-checkout-only')) return;
        if (replay.has(form)) { replay.delete(form); return; }
        if (form.matches('#net-order-form,#wpdNetMainForm')) {
          const choice = document.querySelector('ym-shipping-choice:not([data-demo])');
          if (choice && choice.beginCheckout) {
            event.preventDefault(); event.stopImmediatePropagation();
            if (!service.checkoutBusy) choice.beginCheckout(form, event.submitter);
          }
          return;
        }
        const path = pathOf(form.action);
        if (!/\/cart\/(add|change|clear)$/.test(path)) return;
        event.preventDefault(); event.stopImmediatePropagation();
        if (service.checkoutBusy || form.dataset.ymPending === 'true') return;
        form.dataset.ymPending = 'true';
        try {
          await invalidate();
          changed();
          replay.add(form);
          form.requestSubmit(event.submitter || undefined);
        } catch (_) { showError(form); }
        finally { delete form.dataset.ymPending; }
      }, true);
      if (window.jQuery) {
        window.jQuery(document).on('ajaxComplete.ymShippingLaunch', (_event, response, settings) => {
          if (!settings || !/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(settings.url) || response.status >= 400) return;
          changed();
          invalidate().catch(() => {});
        });
      }
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) { service.checkoutBusy = false; changed(); service.ready = invalidate(); service.ready.catch(() => {}); }
      });
      service.ready = invalidate();
      service.ready.catch(() => {});
      document.dispatchEvent(new CustomEvent('ym:shipping-ready'));
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-stock-warning-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ym-product-stock-warning')) {
    customElements.define('ym-product-stock-warning', class extends HTMLElement {
      connectedCallback() {
        if (this.form) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.panel = this.querySelector('[data-stock-warning]');
        this.message = this.querySelector('[data-stock-message]');
        this.variants = Array.from(this.querySelectorAll('[data-stock-variant]'), (node) => ({
          id: node.dataset.stockVariant,
          stock: Number(node.dataset.stock),
          cartQuantity: Number(node.dataset.cartQuantity),
          status: node.dataset.status,
          schema: node.dataset.schema,
          eligible: node.dataset.tracked === 'true' && node.dataset.policy === 'continue' && node.dataset.physical === 'true' && node.dataset.available === 'true',
          options: JSON.parse(node.dataset.options)
        }));
        this.queueUpdate = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateWarning());
        };
        this.form.addEventListener('input', this.queueUpdate);
        this.form.addEventListener('change', this.queueUpdate);
        this.form.addEventListener('click', this.queueUpdate);
        this.form.addEventListener('submit', this.queueUpdate);
        this.onQuantityClick = (event) => this.adjustQuantity(event);
        this.form.addEventListener('click', this.onQuantityClick, true);
        this.container = this.closest('[data-section-type]') || this.form;
        if (window.jQuery) {
          window.jQuery(this.form).on('change.ymStockWarning', this.queueUpdate);
          window.jQuery(this.container).on('variantChange.ymStockWarning', this.queueUpdate);
        }
        this.queueUpdate();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (!this.form) return;
        ['input', 'change', 'click', 'submit'].forEach((name) => this.form.removeEventListener(name, this.queueUpdate));
        this.form.removeEventListener('click', this.onQuantityClick, true);
        if (window.jQuery) {
          window.jQuery(this.form).off('change.ymStockWarning', this.queueUpdate);
          window.jQuery(this.container).off('variantChange.ymStockWarning', this.queueUpdate);
        }
        this.form = null;
      }
      adjustQuantity(event) {
        const button = event.target.closest('.qtyBtn');
        if (!button || !this.form.contains(button)) return;
        const field = button.closest('.qtyField');
        const input = field && field.querySelector('[name="quantity"]');
        if (!input) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const current = Number(input.value);
        const next = Math.max(1, (Number.isInteger(current) && current > 0 ? current : 1) + (button.classList.contains('plus') ? 1 : -1));
        const maximum = Number(input.getAttribute('max'));
        input.value = String(input.hasAttribute('max') && Number.isFinite(maximum) && maximum > 0 ? Math.min(next, maximum) : next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        this.queueUpdate();
      }
      updateWarning() {
        const master = this.form.querySelector('[name="id"]');
        let variant = this.variants.find((entry) => entry.id === String(master ? master.value : this.dataset.selected));
        const selectors = Array.from(this.form.querySelectorAll('.single-option-selector[data-index]'));
        if (selectors.length) {
          const options = variant ? variant.options.slice() : [];
          selectors.forEach((input) => { options[Number(input.dataset.index.replace('option', '')) - 1] = input.value; });
          variant = this.variants.find((entry) => entry.options.every((value, index) => value === options[index]));
        }
        const input = this.form.querySelector('[name="quantity"]');
        const quantity = Number(input ? input.value : 1);
        let cartQuantity = variant ? variant.cartQuantity : 0;
        if (variant && window.CartJS && window.CartJS.cart && Array.isArray(window.CartJS.cart.items)) {
          cartQuantity = window.CartJS.cart.items.reduce((total, item) => total + (String(item.variant_id || item.id) === variant.id ? Number(item.quantity) : 0), 0);
        }
        const waiting = Boolean(variant && variant.eligible && Number.isInteger(quantity) && quantity > 0 && quantity + cartQuantity > variant.stock);
        this.panel.hidden = !waiting;
        this.message.textContent = waiting ? (variant.stock === 0 ? this.dataset.out : this.dataset.partial) : '';
        this.updateStockStatus(variant);
      }
      updateStockStatus(variant) {
        if (!this.container) return;
        this.container.querySelectorAll('[data-ym-stock-status]').forEach((status) => {
          if (status.dataset.productId !== this.dataset.productId) return;
          status.textContent = variant ? variant.status : status.dataset.unavailable;
        });
        this.container.querySelectorAll('[data-ym-stock-schema]').forEach((holder) => {
          if (holder.dataset.productId !== this.dataset.productId) return;
          holder.replaceChildren();
          if (variant && variant.schema) {
            const link = document.createElement('link');
            link.setAttribute('itemprop', 'availability');
            link.setAttribute('href', variant.schema);
            holder.appendChild(link);
          }
        });
      }
    });
  }
  if (window.jQuery && !window.ymStockAjaxListener) {
    window.ymStockAjaxListener = true;
    window.jQuery(document).on('ajaxComplete.ymStockWarning', (_event, response, settings) => {
      if (!settings || !/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(settings.url) || response.status >= 400) return;
      document.querySelectorAll('ym-product-stock-warning').forEach((warning) => warning.queueUpdate && warning.queueUpdate());
      document.querySelectorAll('ym-shipping-choice:not([data-demo])').forEach((choice) => choice.invalidateChoice && choice.invalidateChoice());
    });
  }
  } catch(e) { console.error(e); }
})();

})();
